import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import { RouterProvider, createBrowserRouter, Navigate } from "react-router-dom";
import Main from "./Main";
import { PageContextProvider } from "./context/PageContext";
import CloudProviders from "./views/CloudProviders";
// import OrganisationsHierarchy from "./views/organize/OrganisationsHierarchy";
// import ProductsHierarchy from "./views/organize/ProductsHierarchy";
// import ProductsMappingsTags from "./views/organize/ProductsMappingsTags";
// import ProductsMappingsBuildSources from "./views/organize/ProductsMappingsBuildSources";
import ComponentsHierarchy from "./views/organize/ComponentsHierarchy";
import ComponentsMappings from "./views/organize/ComponentsMappings";
import Overview from "./views/Overview";
import Analyzer from "./views/cost-analyzer/Analyzer";
import Allocate from "./views/Allocate";
import Login from "./views/Login";
import ResourceList from "./views/resources/ResourceList";
// import ProductList from "./views/products/ProductList";
// import ProductOverview from "./views/products/ProductOverview";
// import ProductResources from "./views/products/ProductResources";
import ResourceDetails from "./views/resources/ResourceDetails";
// import ProductCostDetails from "./views/products/ProductCostDetails";
import CapabilityRoute from "./authz/CapabilityRoute";
import { CAPS } from "./authz/capabilities";
import DataImportsListPage from "./views/data-imports/DataImportsListPage";
import DataImportDetailPage from "./views/data-imports/DataImportDetailPage";
import DataImportsLogDetail from "./views/data-imports/DataImportsLogDetail";
import ReportingJobsPage from "./views/data-imports/ReportingJobsPage";
import UntaggedCostComponents from "./views/tags/UntaggedCostComponents";
import UntaggedResources from "./views/tags/UntaggedResources";
// import CreateReport from "./views/reports/CreateReport";
// Custom Report removed from sidebar + routes; component code kept.
// import ReportEditor from "./views/reports/ReportEditor";
import ReportPrint from "./views/reports/ReportPrint";
import BoardReportPrint from "./views/board-reports/BoardReportPrint";
import BoardReportReview from "./views/board-reports/BoardReportReview";
import BoardReportPreview from "./views/board-reports/BoardReportPreview";
import BoardReportList from "./views/board-reports/BoardReportList";
import BoardReportConfig from "./views/board-reports/BoardReportConfig";
import BoardReportHome from "./views/board-reports/BoardReportHome";
import BoardReportTemplateAdmin from "./views/board-reports/BoardReportTemplateAdmin";
import { HomeTabRedirect } from "./views/board-reports/redirects";
// import ReportList from "./views/reports/ReportList"; // Custom Report — kept, unrouted
import OrganisationalAllOverview from "./views/organization/OrganisationalAll_Overview";
import OrganizationL1Overview from "./views/organization/OrganizationL1_Overview";
import OrganizationL2Overview from "./views/organization/OrganizationL2_Overview";
import OrganizationL3Overview from "./views/organization/OrganizationL3_Overview";
import OrganizationL4Overview from "./views/organization/OrganizationL4_Overview";
import OrganizationL5Overview from "./views/organization/OrganizationL5_Overview";
import AllocationDetails from "./views/organization/AllocationDetails";
import OrganisationalCostOverview from "./views/organization/OrganisationalCostOverview";
import HierarchyManager from "./views/cost-allocation/HierarchyManager";
import "./react-tooltip.css";
import { QueryClient } from "@tanstack/react-query";
import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import { makePersister, PERSIST_MAX_AGE, PERSIST_BUSTER } from "./lib/queryPersist";
import UntaggedOverview from "./views/tags/UntaggedOverview";
import InsightsOverview from "./views/insights/InsightsOverview";
import GeneralConfiguration from "./views/configuration/GeneralConfiguration";
import SlackConfiguration from "./views/configuration/SlackConfiguration";
import GitHubConfiguration from "./views/configuration/GitHubConfiguration";
import InternalConfiguration from "./views/configuration/InternalConfiguration";
import UsersConfiguration from "./views/configuration/UsersConfiguration";
import OrganisationConfiguration from "./views/configuration/OrganisationConfiguration";
import { ReactKeycloakProvider } from "@react-keycloak/web";
import keycloak, { isPlatformRealm } from "./keycloak";
import platformRouter from "./platform/platformRouter";
import { redirectToLogin } from "./api/redirectToLogin";
import PrivateRoute from "./helpers/PrivateRoute";
import ResourceChanges from "./views/resources/ResourceChanges";
import DedicatedErrorPage from "./views/error/DedicatedErrorPage";
import Forecast from "./views/cost-analyzer/Forecast";
import VirtualTags from "./views/cost-allocation/VirtualTags";
import BudgetsListPage from "./views/Budgets/BudgetsListPage";
import BudgetCockpitPage from "./views/Budgets/BudgetCockpitPage";
import ApprovalsInboxPage from "./views/approvals/ApprovalsInboxPage";
import ApprovalRequestDetailPage from "./views/approvals/ApprovalRequestDetailPage";
import DelegationsPage from "./views/approvals/DelegationsPage";
import ApprovalPoliciesPage from "./views/approvals/ApprovalPoliciesPage";
import ApprovalPolicyEditorPage from "./views/approvals/ApprovalPolicyEditorPage";
import UsersListPage from "./views/users/UsersListPage";
import UserCreatePage from "./views/users/UserCreatePage";
import UserDetailPage from "./views/users/UserDetailPage";
import InviteAcceptPage from "./views/users/InviteAcceptPage";
import RolesCatalogPage from "./views/roles/RolesCatalogPage";
import CustomRoleEditor from "./views/roles/CustomRoleEditor";
import OrgRoleWizard from "./views/roles/OrgRoleWizard";
import SourceConnectionsPage from "./views/source-connections/SourceConnectionsPage";
import ConnectionDetailPage from "./views/source-connections/ConnectionDetailPage";
import FinancialOwnershipPage from "./views/allocation/FinancialOwnershipPage";
import FinancialControlPage from "./views/cost-control/FinancialControlPage";
import UseCasePortfolioPage from "./views/use-cases/UseCasePortfolioPage";
import UseCaseDetailPage from "./views/use-cases/UseCaseDetailPage";
import AiUsagePage from "./views/litellm/AiUsagePage";
import OwnershipAccountabilityPage from "./views/cost-control/ownership/OwnershipAccountabilityPage";
import ForecastPredictabilityPage from "./views/cost-control/forecast/ForecastPredictabilityPage";
import ForecastLabPage from "./views/cost-control/forecast-lab/ForecastLabPage";
import InvestigationsListPage from "./views/investigations/InvestigationsListPage";
import InvestigationDetailPage from "./views/investigations/InvestigationDetailPage";
import AnalysisListPage from "./views/analysis/AnalysisListPage";
import AnalysisWorkspacePage from "./views/analysis/AnalysisWorkspacePage";
import CommitmentsListPage from "./views/commitments/CommitmentsListPage";
import OptimizationProgrammePage from "./views/optimization-programme/OptimizationProgrammePage";
import DefineSourcePage from "./views/allocation/components/DefineSourcePage";
import DetectedCostSourcesPage from "./views/allocation/DetectedCostSourcesPage";
import NamesRegistryPage from "./views/allocation/NamesRegistryPage";
import CostSourceTaxonomyPage from "./views/admin/CostSourceTaxonomyPage";
import ProviderMappingPage from "./views/admin/ProviderMappingPage";
import ApplicationParametersPage from "./views/configuration/ApplicationParametersPage";
import LitellmIngestTokensPage from "./views/configuration/LitellmIngestTokensPage";
import ServiceAccountsPage from "./views/service-accounts/ServiceAccountsPage";
import AccessReviewPage from "./views/access-review/AccessReviewPage";
import AuditEvidencePage from "./views/audit-evidence/AuditEvidencePage";
import InvoiceProcessingPage from "./views/invoices/InvoiceProcessingPage";
import InvoiceAutomationSettingsPage from "./views/invoices/InvoiceAutomationSettingsPage";
import InvoiceReviewDetailPage from "./views/invoices/InvoiceReviewDetailPage";
import InvoiceInboundTokensPage from "./views/invoices/InvoiceInboundTokensPage";
import AiSubscriptionPlanForm from "./views/settings/AiSubscriptionPlanForm";
import BudgetEnforcementPage from "./views/budget-enforcement/BudgetEnforcementPage";
import PolicyListPage from "./views/budget-enforcement/policies/PolicyListPage";
import PolicyEditorPage from "./views/budget-enforcement/policies/PolicyEditorPage";
import SettingsLayout from "./layouts/SettingsLayout";
import SettingsHome from "./views/settings/SettingsHome";

// Patch ResizeObserver to defer callbacks and avoid "ResizeObserver loop" errors (e.g. from React Flow).
// Must run before any code that uses ResizeObserver.
const NativeResizeObserver = window.ResizeObserver;
if (NativeResizeObserver) {
	window.ResizeObserver = class ResizeObserver extends NativeResizeObserver {
		constructor(callback) {
			super((entries, observer) => {
				requestAnimationFrame(() => callback(entries, observer));
			});
		}
	};
}

// Check if we're in print mode (for PDF generation)
const urlParams = new URLSearchParams(window.location.search);
const isPrintMode = urlParams.get('print') === 'true';
const injectedToken = urlParams.get('token');

// Suppress benign ResizeObserver loop error before any other code runs (capture phase)
// so React/dev overlay and other handlers never see it (browser quirk, often from React Flow)
function isResizeObserverLoopError(message, error) {
	const msg = typeof message === "string" ? message : (error && error.message) || "";
	return msg.includes("ResizeObserver loop");
}
window.addEventListener(
	"error",
	function (event) {
		if (isResizeObserverLoopError(event.message, event.error)) {
			event.stopImmediatePropagation();
			event.preventDefault();
			return true;
		}
	},
	true
);

// In print mode, inject the token into keycloak BEFORE any initialization
if (isPrintMode && injectedToken) {
	console.log('Print mode detected, injecting token');
	// Pre-configure keycloak with the token - this must happen before React renders
	keycloak.token = injectedToken;
	keycloak.refreshToken = injectedToken;
	keycloak.idToken = injectedToken;
	keycloak.authenticated = true;
	keycloak.subject = 'pdf-generator';
	keycloak.tokenParsed = { 
		realm_access: { roles: [] }, 
		exp: Math.floor(Date.now() / 1000) + 3600,
		sub: 'pdf-generator'
	};
	keycloak.refreshTokenParsed = { exp: Math.floor(Date.now() / 1000) + 3600 };
	keycloak.idTokenParsed = { sub: 'pdf-generator' };
	
	// Override methods to prevent any Keycloak server calls
	keycloak.updateToken = () => Promise.resolve(false);
	keycloak.login = () => Promise.resolve();
	keycloak.logout = () => Promise.resolve();
	keycloak.init = () => Promise.resolve(true);
	keycloak.onTokenExpired = null;
	keycloak.onAuthSuccess = null;
	keycloak.onAuthError = null;
}

// Configure QueryClient with default options for token refresh handling
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        // Don't retry on 401/403 (handled by token refresh in authenticatedFetch)
        if (error?.message?.includes('401') || error?.message?.includes('403')) {
          return false;
        }
        // Retry other errors up to 3 times
        return failureCount < 3;
      },
      staleTime: 15 * 60 * 1000, // 15 minutes — figure/dashboard data is stable within a period
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: (failureCount, error) => {
        // Don't retry mutations on 401/403
        if (error?.message?.includes('401') || error?.message?.includes('403')) {
          return false;
        }
        return failureCount < 1; // Only retry once for mutations
      },
    },
  },
});

// Health check component for /health/live
function HealthLive() {
	const response = {
		status: "alive",
		timestamp: new Date().toISOString(),
	};
	
	return (
		<pre style={{ 
			fontFamily: "monospace", 
			padding: "20px",
			margin: 0,
			whiteSpace: "pre-wrap"
		}}>
			{JSON.stringify(response, null, 2)}
		</pre>
	);
}

const router = createBrowserRouter([
	{
		path: "/",
		element: <App />,
		children: [
			{
				path: "/health/live",
				element: <HealthLive />,
			},
			{
				path: "/",
				// PageContextProvider needs useLocation, which only resolves inside
				// the router's rendered tree — so it's mounted here (as part of this
				// route's element), immediately above Main/TopBar, rather than
				// wrapped around <RouterProvider> itself.
				element: <PrivateRoute><PageContextProvider><Main /></PageContextProvider></PrivateRoute>,
				children: [
					{ path: "/", element: <Navigate to="/financial-control" replace /> },
					{ path: "/overview", element: <Overview /> },
					{ path: "/financial-control", element: <FinancialControlPage /> },
					{ path: "/use-cases", element: <UseCasePortfolioPage /> },
					{ path: "/use-cases/:nodeId", element: <UseCaseDetailPage /> },
					{ path: "/use-cases/:nodeId/financials", element: <UseCaseDetailPage /> },
					{ path: "/use-cases/:nodeId/value", element: <UseCaseDetailPage /> },
					{ path: "/use-cases/:nodeId/usage", element: <UseCaseDetailPage /> },
					{ path: "/ai-monitor", element: <AiUsagePage /> },
					{ path: "/ownership-accountability", element: <OwnershipAccountabilityPage /> },
					{ path: "/forecast-predictability", element: <ForecastPredictabilityPage /> },
					{ path: "/forecast-lab", element: <ForecastLabPage /> },
					{ path: "/investigations", element: <InvestigationsListPage /> },
					{ path: "/investigations/:id", element: <InvestigationDetailPage /> },
					{ path: "/analysis", element: <AnalysisListPage /> },
					{ path: "/analysis/:id", element: <AnalysisWorkspacePage /> },
					{ path: "/commitments", element: <CommitmentsListPage /> },
					{ path: "/optimization-programme", element: <OptimizationProgrammePage /> },
					{ path: "/cost-analyzer", element: <Analyzer /> },
					{ path: "/cost-forecast", element: <Forecast /> },
					// {
					// 	path: "/organize-organisations",
					// 	element: <OrganisationsHierarchy />,
					// },
					// { path: "/organize-products", element: <ProductsHierarchy /> },
					// { path: "/products-mapping-tags", element: <ProductsMappingsTags /> },
					// {
					// 	path: "/products-mapping-build-sources",
					// 	element: <ProductsMappingsBuildSources />,
					// },
					// {
					// 	path: "/organisations-mapping",
					// 	element: <OrganisationsMappings />,
					// },
					{ path: "/organize-components", element: <ComponentsHierarchy /> },
					{ path: "/components-mapping", element: <ComponentsMappings /> },
					{ path: "/cloudproviders", element: <CloudProviders /> },
					{ path: "/allocate", element: <Allocate /> },
					{ path: "/resources", element: <ResourceList /> },
					{ path: "/resource/:id", element: <ResourceDetails /> },
					// { path: "/product-list", element: <ProductList /> },
					// { path: "/product-overview/:id", element: <ProductOverview /> },
					// { path: "/product-resources/:id", element: <ProductResources /> },
					// {
					// 	path: "/product-cost-details/:id",
					// 	element: <ProductCostDetails />,
					// },
					{ path: "/invoice-review", element: <CapabilityRoute requires={[CAPS.INVOICES_REVIEW]}><InvoiceProcessingPage /></CapabilityRoute> },
					{ path: "/invoice-review/settings", element: <CapabilityRoute requires={[CAPS.INVOICES_REVIEW]}><InvoiceAutomationSettingsPage /></CapabilityRoute> },
					{ path: "/invoice-review/:id", element: <CapabilityRoute requires={[CAPS.INVOICES_REVIEW]}><InvoiceReviewDetailPage /></CapabilityRoute> },
					{ path: "/untagged-cost-resources", element: <UntaggedCostComponents /> },
					{ path: "/untagged-resources", element: <UntaggedResources /> },
					{ path: "/untagged-overview", element: <UntaggedOverview /> },
					// Custom Report removed from the sidebar + routes (component code kept):
					// { path: "/report-editor/:id", element: <ReportEditor /> },
					// { path: "/report-list", element: <ReportList /> },
					// { path: "/new-report", element: <CreateReport /> },
					{ path: "/organisational-overview", element: <OrganisationalAllOverview /> },
					{ path: "/organization-l1-overview", element: <OrganizationL1Overview /> },
					{ path: "/organization-l2-overview", element: <OrganizationL2Overview /> },
					{ path: "/organization-l3-overview", element: <OrganizationL3Overview /> },
					{ path: "/organization-l4-overview", element: <OrganizationL4Overview /> },
					{ path: "/organization-l5-overview", element: <OrganizationL5Overview /> },
					{ path: "/allocation-details", element: <AllocationDetails /> },
					{ path: "/organisational-cost-overview", element: <OrganisationalCostOverview /> },
					{ path: "/insights", element: <InsightsOverview /> },
					{ path: "/gcp-configuration", element: <Navigate to="/source-connections" replace /> },
					{ path: "/configuration", element: <GeneralConfiguration /> },
					{ path: "/slack-configuration", element: <SlackConfiguration /> },
					{ path: "/github-configuration", element: <GitHubConfiguration /> },
					{ path: "/internal-configuration", element: <InternalConfiguration /> },
					{ path: "/users-configuration", element: <UsersConfiguration /> },
					{ path: "/organisation-configuration", element: <OrganisationConfiguration /> },
					{ path: "/resource-changes", element: <ResourceChanges /> },
					{ path: "/budgets", element: <BudgetsListPage /> },
					{ path: "/budgets/new", element: <BudgetCockpitPage /> },
					{ path: "/budgets/:id", element: <BudgetCockpitPage /> },
					{ path: "/approvals", element: <ApprovalsInboxPage /> },
					{ path: "/approvals/:id", element: <ApprovalRequestDetailPage /> },
					{ path: "/control-policies/delegations", element: <DelegationsPage /> },
					{ path: "/control-policies/approval-policies", element: <ApprovalPoliciesPage /> },
					{ path: "/control-policies/approval-policies/new", element: <ApprovalPolicyEditorPage /> },
					{ path: "/control-policies/approval-policies/:id", element: <ApprovalPolicyEditorPage /> },
					{ path: "/budget-enforcement", element: <BudgetEnforcementPage /> },
					{ path: "/budget-enforcement/policies", element: <PolicyListPage /> },
					{ path: "/budget-enforcement/policies/new", element: <PolicyEditorPage /> },
					{ path: "/budget-enforcement/policies/:id", element: <PolicyEditorPage /> },
					{ path: "/board-reports", element: <BoardReportList /> },
					{ path: "/board-reports/new/config", element: <BoardReportConfig /> },
					{ path: "/board-reports/:id", element: <BoardReportHome /> },
					{ path: "/board-reports/:id/config", element: <HomeTabRedirect tab="settings" /> },
					{ path: "/board-reports/:id/template", element: <CapabilityRoute requires={[CAPS.REPORTS_BOARD_MANAGE]}><BoardReportTemplateAdmin /></CapabilityRoute> },
					{ path: "/board-reports/:id/runs", element: <HomeTabRedirect tab="runs" /> },
					{ path: "/board-reports/:id/runs/:runId/review", element: <BoardReportReview /> },
					{ path: "/board-reports/:id/runs/:runId/preview", element: <BoardReportPreview /> },
				],
			},
			{
				path: "/",
				element: <PrivateRoute><PageContextProvider><SettingsLayout /></PageContextProvider></PrivateRoute>,
				children: [
					{ path: "/settings", element: <SettingsHome /> },
					{ path: "/allocation", element: <FinancialOwnershipPage /> },
					{ path: "/allocation/sources/new", element: <DefineSourcePage /> },
					{ path: "/allocation/sources/:id", element: <DefineSourcePage /> },
					{ path: "/detected-sources", element: <DetectedCostSourcesPage /> },
					{ path: "/allocation/names", element: <NamesRegistryPage /> },
					{ path: "/cost-allocation/hierarchy", element: <HierarchyManager /> },
					{ path: "/virtual-tags", element: <VirtualTags /> },
					{ path: "/cost-source-taxonomy", element: <CapabilityRoute requires={[CAPS.CONFIG_DIMENSIONS]}><CostSourceTaxonomyPage /></CapabilityRoute> },
					{ path: "/source-connections", element: <CapabilityRoute requires={[CAPS.INTEGRATIONS_MANAGE]}><SourceConnectionsPage /></CapabilityRoute> },
					{ path: "/source-connections/:id", element: <CapabilityRoute requires={[CAPS.INTEGRATIONS_MANAGE]}><ConnectionDetailPage /></CapabilityRoute> },
					{ path: "/data-pipeline", element: <CapabilityRoute requires={[CAPS.INTEGRATIONS_MANAGE]}><DataImportsListPage /></CapabilityRoute> },
					{ path: "/data-pipeline/log/:id", element: <CapabilityRoute requires={[CAPS.INTEGRATIONS_MANAGE]}><DataImportsLogDetail /></CapabilityRoute> },
					{ path: "/data-pipeline/:id", element: <CapabilityRoute requires={[CAPS.INTEGRATIONS_MANAGE]}><DataImportDetailPage /></CapabilityRoute> },
					{ path: "/reporting-jobs", element: <CapabilityRoute requires={[CAPS.INTEGRATIONS_MANAGE]}><ReportingJobsPage /></CapabilityRoute> },
					{ path: "/reporting-jobs/:id", element: <CapabilityRoute requires={[CAPS.INTEGRATIONS_MANAGE]}><DataImportDetailPage /></CapabilityRoute> },
					{ path: "/provider-mappings", element: <CapabilityRoute requires={[CAPS.CONFIG_DIMENSIONS]}><ProviderMappingPage /></CapabilityRoute> },
					{ path: "/application-parameters", element: <CapabilityRoute requires={[CAPS.TENANT_CONFIGURE]}><ApplicationParametersPage /></CapabilityRoute> },
					{ path: "/litellm-ingest-tokens", element: <CapabilityRoute requires={[CAPS.INTEGRATIONS_MANAGE]}><LitellmIngestTokensPage /></CapabilityRoute> },
					{ path: "/invoice-inbound-tokens", element: <CapabilityRoute requires={[CAPS.INTEGRATIONS_MANAGE]}><InvoiceInboundTokensPage /></CapabilityRoute> },
					{ path: "/settings/ai-subscription", element: <CapabilityRoute requires={[CAPS.CONFIG_ALLOC_MODELS]}><AiSubscriptionPlanForm /></CapabilityRoute> },
					{ path: "/settings/users", element: <CapabilityRoute requires={[CAPS.USERS_MANAGE]}><UsersListPage /></CapabilityRoute> },
					{ path: "/settings/users/new", element: <CapabilityRoute requires={[CAPS.USERS_MANAGE]}><UserCreatePage /></CapabilityRoute> },
					{ path: "/settings/users/:id", element: <CapabilityRoute requires={[CAPS.USERS_MANAGE]}><UserDetailPage /></CapabilityRoute> },
					{ path: "/settings/roles", element: <CapabilityRoute requires={[CAPS.ROLES_ASSIGN]}><RolesCatalogPage /></CapabilityRoute> },
					{ path: "/settings/roles/new", element: <CapabilityRoute requires={[CAPS.ROLES_ASSIGN]}><OrgRoleWizard /></CapabilityRoute> },
					{ path: "/settings/roles/:id", element: <CapabilityRoute requires={[CAPS.ROLES_ASSIGN]}><CustomRoleEditor /></CapabilityRoute> },
					{ path: "/settings/service-accounts", element: <CapabilityRoute requires={[CAPS.SERVICE_ACCOUNTS_MANAGE]}><ServiceAccountsPage /></CapabilityRoute> },
					{ path: "/settings/access-review", element: <CapabilityRoute requires={[CAPS.ACCESS_REVIEW]}><AccessReviewPage /></CapabilityRoute> },
					{ path: "/settings/audit-evidence", element: <CapabilityRoute requires={[CAPS.AUDIT_EXPORT]}><AuditEvidencePage /></CapabilityRoute> },
				],
			},
			{
				path: "/invite",
				element: <PrivateRoute><InviteAcceptPage /></PrivateRoute>,
			},
			{
				path: "/report-print/:id",
				element: <PrivateRoute><ReportPrint /></PrivateRoute>,
			},
			{
				path: "/board-report-print/:id/:runId",
				element: <PrivateRoute><BoardReportPrint /></PrivateRoute>,
			},
			{
				path: "/login",
				element: <Login />,
			},
			{
				path: "/error",
				element: <DedicatedErrorPageWrapper />,
			},
		],
	},
], {
	future: {
		v7_startTransition: true,
	},
});

// Persist the react-query cache to localStorage across reloads. `buster` changes
// per deploy so an incompatible cache shape is dropped instead of hydrating stale data.
const queryPersister = makePersister();
const persistOptions = {
	persister: queryPersister,
	maxAge: PERSIST_MAX_AGE,
	buster: PERSIST_BUSTER,
};

const root = ReactDOM.createRoot(document.getElementById("root"));

// Configure Keycloak init options based on mode
const keycloakInitOptions = isPrintMode && injectedToken
	? {
		// In print mode, skip all Keycloak server communication
		onLoad: undefined, // Don't auto-load anything
		checkLoginIframe: false,
		silentCheckSsoRedirectUri: undefined,
		enableLogging: false,
	}
	: {
		onLoad: 'login-required', // Forces login if not authenticated
		checkLoginIframe: false, // Prevents iframe checks that might trigger popups
		pkceMethod: 'S256', // Uses PKCE for security
		enableLogging: false // Disable logging for production
	};

// Custom initialization handler for print mode
const handleKeycloakEvent = (event, error) => {
	if (isPrintMode && injectedToken) {
		console.log('Print mode - Keycloak event:', event);
		if (event === 'onReady') {
			keycloak.token = injectedToken;
			keycloak.authenticated = true;
		}
		return;
	}
	if (event === 'onTokenExpired') {
		// Try a silent refresh while the SSO session is still alive. Do NOT redirect to login on
		// failure: these events fire on a background timer (often while the tab is idle/backgrounded),
		// so redirecting here opens a Keycloak login flow that has already gone stale by the time the
		// user returns and submits — which surfaces as "Your login attempt timed out". The redirect
		// instead happens lazily on the next authenticated request (authenticatedFetch), i.e. at
		// user-action time, so the login session is fresh.
		keycloak.updateToken(30).catch(() => {});
	}
	// onAuthRefreshError fires when a background refresh fails — same reasoning: handle it lazily at
	// the next request rather than opening a login flow that will go stale.
};

root.render(
	// <React.StrictMode>
		<ReactKeycloakProvider 
			authClient={keycloak} 
			initOptions={keycloakInitOptions}
			onEvent={handleKeycloakEvent}
			LoadingComponent={isPrintMode ? null : undefined}
		>
			<PersistQueryClientProvider client={queryClient} persistOptions={persistOptions}>
				{/* A UI branch only: the operator console is served from this same
				    bundle on platform.instantview.ai. The API refuses on its own,
				    from the token. */}
				<RouterProvider
					router={isPlatformRealm ? platformRouter : router}
					future={{
						v7_startTransition: true,
					}}
				/>
			</PersistQueryClientProvider>
		</ReactKeycloakProvider>
	// </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// reportWebVitals();

window.onerror = function (message, source, lineno, colno, error) {
	// Suppress benign ResizeObserver loop error (browser quirk, often from React Flow/charts)
	if (isResizeObserverLoopError(message, error)) {
		return true;
	}
	const errorMessage = message || (error && error.toString()) || '';
	// Suppress token refresh errors — handled by redirecting to login
	if (errorMessage.includes('refresh token') || errorMessage.includes('Session expired')) {
		redirectToLogin();
		return true;
	}
	// In print mode, suppress all errors (including PropTypes validation errors)
	if (isPrintMode) {
		console.error('Print mode - suppressing error redirect');
		return true;
	}
	console.error('Global error:', { message, source, lineno, colno, error });
	localStorage.setItem('globalError', message || (error && error.toString()) || "Unknown error");
	if (window.location.pathname !== '/error') {
		window.history.pushState({}, '', '/error');
		window.dispatchEvent(new PopStateEvent('popstate'));
	}
};

window.onunhandledrejection = function (event) {
	// Suppress ResizeObserver loop when reported as unhandled rejection
	if (isResizeObserverLoopError(event.reason?.message, event.reason)) {
		event.preventDefault();
		return;
	}
	const errorMessage = event.reason ? event.reason.toString() : '';
	// Suppress token refresh errors — handled by redirecting to login
	if (errorMessage.includes('refresh token') || errorMessage.includes('Session expired')) {
		event.preventDefault();
		redirectToLogin();
		return;
	}
	// In print mode, suppress all promise rejections
	if (isPrintMode) {
		console.error('Print mode - suppressing error redirect');
		event.preventDefault();
		return;
	}
	console.error('Unhandled promise rejection:', event.reason);
	localStorage.setItem('globalError', event.reason ? event.reason.toString() : "Unknown error");
	if (window.location.pathname !== '/error') {
		window.history.pushState({}, '', '/error');
		window.dispatchEvent(new PopStateEvent('popstate'));
	}
};

// Wrapper to extract error message from query string and pass to DedicatedErrorPage
function DedicatedErrorPageWrapper() {
	const msg = localStorage.getItem('globalError');
	return <DedicatedErrorPage error={msg} />;
}
